// Ruteo por calles (Valhalla, a través del servidor: POST /v2/routes/street/*).
// RoutePlanner lo recibe como prop; sin él, o si falla, todo sigue en línea
// recta como antes.

import type { Pt } from "./routeOrder";

// Tiempo (s) y distancia (km) de cada punto a cada otro; null = sin camino.
export type StreetMatrix = { seconds: (number | null)[][]; km: (number | null)[][] };
// Recorrido en el orden dado: un tramo codificado por cada par de puntos.
export type StreetShape = { shapes: string[]; km: number; seconds: number };
export type StreetRouting = {
  matrix: (points: Pt[]) => Promise<StreetMatrix>;
  shape: (points: Pt[]) => Promise<StreetShape>;
};

// Tope del servidor: 200 paradas más inicio y fin.
export const STREET_MAX_POINTS = 202;

// Polyline codificada de Valhalla (precisión 6) → [[lat, lng], ...].
export function decodePolyline(encoded: string, precision = 6): [number, number][] {
  const factor = 10 ** precision;
  const out: [number, number][] = [];
  let index = 0, lat = 0, lng = 0;
  while (index < encoded.length) {
    for (const which of [0, 1]) {
      let shift = 0, result = 0, byte: number;
      do {
        byte = encoded.charCodeAt(index++) - 63;
        result |= (byte & 0x1f) << shift;
        shift += 5;
      } while (byte >= 0x20 && index < encoded.length);
      const delta = result & 1 ? ~(result >> 1) : result >> 1;
      if (which === 0) lat += delta; else lng += delta;
    }
    out.push([lat / factor, lng / factor]);
  }
  return out;
}

export const fmtKm = (km: number) => `${km.toFixed(1).replace(".", ",")} km`;
export function fmtDuration(seconds: number): string {
  const min = Math.round(seconds / 60);
  if (min < 60) return `${min} min`;
  return `${Math.floor(min / 60)} h ${String(min % 60).padStart(2, "0")} min`;
}
